import React, {useEffect, useState} from 'react';
import {getJSONFromHtml} from "../../../domain/common";
import {IDownloadManualListItem} from "../interfaces/interfaces";
import _, {cloneDeep} from "lodash";
import DownloadManualsList from "./download-manuals-list";

const getItemKey = (index:number, category:string) => {
    return `${ index }-${ category }`
};

const DownloadManuals:React.FC = () => {
    const [downloadManualsListData,setDownloadManualsListData]:any = useState([]);
    const [downloadManualsCategories, setDownloadManualsCategoriesList]:any = useState([]);

    useEffect(() => {
        (async() => {
            const downloadManualsListData = document.getElementById('download-manuals-list');
            if (downloadManualsListData) {
                const downloadManuals = getJSONFromHtml(downloadManualsListData) as IDownloadManualListItem[];
                const groupedBy = groupManualsByCategory(downloadManuals);
                setDownloadManualsListData(groupedBy);
            }
        })()
    },[])

    const groupManualsByCategory = (downloadManualsListItems:IDownloadManualListItem[]) => {
        if (downloadManualsListItems && downloadManualsListItems.length > 0){
            const cloned:any[] = cloneDeep(downloadManualsListItems);
            const result = _.groupBy(cloned, downloadManual => downloadManual.categoryName);
            let categoriesList = [];
            for (const [key, value] of Object.entries(result)) {
                categoriesList.push(key);
            }
            setDownloadManualsCategoriesList(categoriesList);
            return result;
        }
    }

    return (
        downloadManualsListData && <div className="waves-box-ml mx-auto px-5 md:px-12 xl:px-0 xl:pl-36">
                {
                    downloadManualsCategories && downloadManualsCategories.map((manualCategory:any, index:number) => {
                        return (
                            <DownloadManualsList key={getItemKey(index,manualCategory)} category={manualCategory} downloadManualsList={downloadManualsListData}/>
                        )
                    })
                }
        </div>
    );
}

export default DownloadManuals;